export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8252.6e72a257.jpg";